import { UserTitleType } from '../enums/user-title-type.enum';
import { Component, OnInit, HostListener, Input } from '@angular/core';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonService } from '../../shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from '../services/cache.service';
import { AppMessageService } from '../../app-message.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { SSO } from '../../sso/sso.constants';
import { AppConstants } from '../../common/constants/app.constants';
import { ActiveSessionService } from '../services/active-session.service';
import { MemberLevel } from '../enums/member-level.enum';
import { PortalCountry } from '../interfaces/portal-country.interface';
import { Country, CountryUrlMetaData } from '../interfaces/country.interface';
import flatten from 'lodash-es/flatten';
@Component({
  selector: 'app-myaccount,[app-myaccount]',
  templateUrl: '../templates/template1/views/app-account.component.html',
  styleUrls: ['../templates/template1/themes/default/less/app-account.less'
  ]
})
export class AppAccountComponent implements OnInit {
  cartHoverValue: boolean;
  memberTitleId: number = MemberLevel.RETAIL;
  isUserLoggedIn = false;
  userInfo: any;
  profileImageURL: string;
  isoCountryCode: any;
  isAccountDropOpen = false;
  userName = '';
  cookieService: CookieService = new CookieService(document);
  @Input() isMobile: boolean;
  @Input() show = false;
  constructor(
    private _appMessageService: AppMessageService,
    private _cacheService: CacheService,
    private _commonService: CommonService,
    private _activeSessionService: ActiveSessionService
  ) {
    if (this._cacheService.get(CacheKey.CountryMetaData)) {
      this._commonService.updateCountryCodeinCookie();
    }
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
  }

  ngOnInit() {
    this.LoggedInUserInfo();
  }
  /**
   * checking whether user is logged in or not
   */
  LoggedInUserInfo(): void {
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (this.userInfo) {
      this.isUserLoggedIn = true;
      this.profileImageURL = this.userInfo.profileImageURL || AppConstants.DEFULT_PROFILEIMG;
      this.memberTitleId = this._activeSessionService.getMemberTitleId();
      this.userName = this.userInfo.firstName;
    } else {
      this.isUserLoggedIn = false;
    }
  }

  /**
   * @returns void
   */
  login(): void {
    this._appMessageService.setNotifyLoginStatus(true);
  }

  /**
    * keyclock logout
    * @returns void
    */
  logout(): void {
    this._appMessageService.setNotifyLoginStatus(false);
  }

  /**
 *
 */
  private getPortalCountry(): Country {
    const portalCountries: PortalCountry[] = this._cacheService.get(CacheKey.PortalCountries);
    if (portalCountries && portalCountries.length > 0) {
      const countries = flatten(
        portalCountries.map(portal => portal.countries));
      const country: Country = countries.find(item => item.isocodeThree.toLowerCase() ===
        this.isoCountryCode.toLowerCase());
      if (country) {
        return country;
      }
    }
  }

  /**
   * to navigate to My account page
   */
  navigateToMyAccount(): void {
    const country = this.getPortalCountry();
    if (country && !country.titanPlatformEnabled && this.userInfo && this.userInfo.memberAllowedCountries
      && this.userInfo.memberAllowedCountries.length > 0) {
      const memberAllowedCountry = this.userInfo.memberAllowedCountries
        .find(item => item.isoCodeThree.toUpperCase() === this.isoCountryCode.toUpperCase());
      if (memberAllowedCountry) {
        this._commonService.navigateToLegacy(this.isoCountryCode).subscribe(response => {
          if (response) {
            window.open((response.redirectUrl + '?store=' + response.store + '&idtoken=' + response.idToken), '_blank');
          }
        });
      }
    } else {
      if (this._cacheService.get(CacheKey.CountryMetaData)) {
        this._commonService.updateCountryCodeinCookie();
      }
      const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
      window.location.href = environment.accountSiteURL + '/' + this.isoCountryCode.toLowerCase() + '/' + languageCode.toLowerCase() +
        '/account/my-profile';
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    const myAccountdDiv = document.getElementsByClassName('account-menu')[0];
    this.showOrHideMyAccount(myAccountdDiv, false);
  }

  /**
   * added for ada complience tab events
   * @param  {any} myAccountdDiv
   * @param  {boolean} show
   */
  showOrHideMyAccount(myAccountdDiv: any, show: boolean) {
    if (myAccountdDiv) {
      if (show) {
        this.isAccountDropOpen = true;
      } else {
        this.isAccountDropOpen = false;
      }
    }
  }
}